import addStartupScript from '../events/addStartupScript';
import { selectors } from './elements/constants';
import { dispatchCustomErrorEvent, events } from './models/events';

export function startup() {
  document.querySelectorAll(selectors.multipleChoicePanel).forEach((panel) => (
    panel.addEventListener(events.navigate, handleNavigate)
  ));
}

/**
 * Handles the navigation event to perform custom validation,
 * checking the number of checked items against the maximum/minimum values.
 *
 * @param {CustomEvent} event
 */
export function handleNavigate(event) {
  if (event.defaultPrevented || event.detail?.direction === 'backwards') return;

  const panel = event.target.closest(selectors.multipleChoicePanel);
  const checkboxesField = panel.querySelector(selectors.checkboxesField);
  if (checkboxesField) {
    const { minimum, maximum } = checkboxesField.dataset;
    const checked = checkboxesField.querySelectorAll('input:checked').length;

    if (minimum && checked < parseInt(minimum)) {
      dispatchCustomErrorEvent(panel, new Error('Please select at least ' + minimum + ' option(s)'));
      event.preventDefault();
    } else if (maximum && checked > parseInt(maximum)) {
      dispatchCustomErrorEvent(panel, new Error('Please select at most ' + maximum + ' option(s)'));
      event.preventDefault();
    }
  }
}

addStartupScript(startup);
